const entries = {
  'company title': ['vagas da empresa','ofertas de la empresa','company vacancies'],
  'recruiter title': ['gerenciar vagas','gestionar ofertas','manage jobs'],
  description: ['gerencie rascunhos, vagas publicadas e candidaturas em um só lugar','gestiona borradores, ofertas publicadas y candidaturas en un solo lugar','manage drafts, published jobs and applications in one place'],
  loading: ['carregando vagas...','cargando ofertas...','loading jobs...'],
  'load error': ['não foi possível carregar as vagas','no se pudieron cargar las ofertas','jobs could not be loaded'],
  retry: ['tentar novamente','volver a intentar','try again'],
  empty: ['nenhuma vaga encontrada','no se encontraron ofertas','no jobs found'],
  'create hint': ['crie uma nova vaga','crea una nueva oferta','create a new job'],
  create: ['criar vaga','crear oferta','create job'],
  recent: ['vagas recentes','ofertas recientes','recent jobs'],
  more: ['ver todas','ver todas','view all'],
  'no match': ['nenhuma vaga corresponde à busca','ninguna oferta coincide con la búsqueda','no jobs match your search'],
  'search label': ['buscar nas vagas da empresa','buscar en las ofertas de la empresa','search company vacancies'],
  placeholder: ['digite para buscar','escribe para buscar','type to search'],
  search: ['procurar','buscar','search'],
  title: ['título','título','title'],
  applications: ['candidaturas','candidaturas','applications'],
  address: ['localização','ubicación','location'],
  date: ['data','fecha','date'],
  status: ['situação','estado','status'],
  actions: ['ações','acciones','actions'],
  edit: ['editar vaga','editar oferta','edit job'],
  duplicate: ['duplicar vaga','duplicar oferta','duplicate job'],
  duplicated: ['vaga duplicada','oferta duplicada','job duplicated'],
  'duplicate error': ['não foi possível duplicar a vaga. Confira as permissões e os limites do plano','no se pudo duplicar la oferta. Revisa los permisos y los límites del plan','the job could not be duplicated. Check permissions and plan limits'],
  total: ['total de','total de','a total of'],
  jobs: ['vagas','ofertas','jobs'],
  specific: ['digite pelo menos três caracteres para buscar','escribe al menos tres caracteres para buscar','enter at least three characters to search'],
  published: ['publicada','publicada','published'],
  validating: ['em análise','en revisión','under review'],
  hidden: ['oculta','oculta','hidden'],
  draft: ['rascunho','borrador','draft'],
  unavailable: ['indisponível','no disponible','unavailable'],
  first: ['primeira página','primera página','first page'],
  previous: ['página anterior','página anterior','previous page'],
  next: ['próxima página','página siguiente','next page'],
  last: ['última página','última página','last page'],
  page: ['página','página','page'],
};
export default Object.fromEntries(['pt','es','en'].map((locale,index)=>[locale,
  Object.fromEntries(Object.entries(entries).map(([key,values])=>[`employer jobs ${key}`,values[index]]))]));
